import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
// import './plugins/vuetify'
import App from './App.vue'
import router from './router'

import * as VueGoogleMaps from 'vue2-google-maps'

import VueScreenSize from 'vue-screen-size'
Vue.use(VueScreenSize)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCsv5eltIcsMq215k2nxvkgvjYar0gecBc',
    //  libraries: 'places',
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
